import { render } from "./matchSubject.vue?vue&type=template&id=4f946524"
import script from "./matchSubject.vue?vue&type=script&lang=js"
export * from "./matchSubject.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__